<template>
  <el-dialog
    class="kye-dialog__modal-in-tab kye-field-help"
    :visible.sync="show"
    v-drag
    :modal="false"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="escape"
    width="500px"
    @close="onClose">
    <div slot="title">
      <span class="el-dialog__title">{{ title }}</span>
    </div>
    <div class="kye-field-help-body" v-loading="loading">
      <div class="kye-field-help-body-search">
        <el-input
          ref="input"
          v-model.trim="searchText"
          class="kye-field-help-body-input"
          placeholder="请输入关键词后可定位到指定项"
          @keypress.enter.native="hanldeNextClick()"
          @input="val => handleTextChange(val)">
        </el-input>
        <el-button class="kye-field-help-body-btn prev" plain @click="hanldePrevClick()">上一个</el-button>
        <el-button class="kye-field-help-body-btn last" plain @click="hanldeNextClick()">下一个</el-button>
      </div>
      <div v-if="!multiTab" style="display: flex;flex: 1;overflow:hidden;flex-direction: column">
        <div ref="helpContent" class="kye-field-help-body-content ql-editor" v-html="newContent"  @click="handleContentClick">
        </div>
      </div>
      <el-tabs v-else ref="tabs" v-model="activeName">
        <el-tab-pane v-for="(tab) in newContent" :key="tab.order" :name="tab.order" :label="tab.indicatorTabName">
          <div ref="helpContent" class="kye-field-help-body-content ql-editor" v-html="tab.newContent" :key="tab.order"  @click="handleContentClick">
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
  import { deviceEvent, getClient } from 'public/components/kye-canvas-table/utils'
  import { cloneDeep } from 'lodash'
  import openPreview from 'public/components/kye-preview/preview'
  export default {
    name: 'kye-field-help',
    props: {
      title: {
        type: String, // 显示弹窗标题
        default: () => '指标说明'
      },
      code: {
        type: String,
        default: () => ''
      },
      menuId: {
        type: String,
        default: () => ''
      },
      content: { // 内容
        type: [String, Array]
      }
    },
    data () {
      return {
        escape: true,
        loading: false,
        show: false,
        originContent: '', // 原始数据用于搜索之后还原
        newContent: '',
        activeName: 0,
        form: {
          indicatorCode: '',
          menuId: ''
        },
        searchText: ''
      }
    },
    watch: {
      $route (val) {
        this.show = false
      }
    },
    computed: {
      multiTab () {
        if (typeof this.originContent === 'string') return false
        if (Array.isArray(this.originContent) && this.originContent.length >= 1) return true
        return false
      }
    },
    mounted () {
      try {
        let w = this.$el.querySelector('.el-dialog').style.width
        w = parseInt(w)
        this.$el.querySelector('.el-dialog').style.left = document.body.clientWidth - w + 'px'
      } catch (e) {
        console.log(e)
      }
    },
    methods: {
      open (option = {}) {
        this.show = true
        this.searchText = ''
        this.form.menuId = option.menuId || this.menuId || this.$store.state.menus[this.$route.meta.tag].id || '' // 菜单id
        this.form.indicatorCode = option.code || this.code || '' // 指标说明编码
        let content = option.content || this.content || ''
        if (Array.isArray(content)) {
          if (content.length > 1) {
            this.newContent = content.map(item => {
              const indicatorContent = item.indicatorContent
              item.originContent = indicatorContent
              item.newContent = indicatorContent
              item.order = item.order.toString()
              return item
            })
            this.activeName = this.newContent[0].order
          } else {
            this.newContent = content[0].indicatorContent
          }
        } else {
          this.newContent = content
        }
        this.originContent = cloneDeep(this.newContent)
        this.$nextTick(() => {
          this.initEvent()
        })
        !this.originContent && this.getHelpData()
      },
      getImages(content) {
        const parser = new DOMParser()
        const doc = parser.parseFromString(content, 'text/html')
        const imgTags = doc.querySelectorAll('img')
        return Array.from(imgTags).map(img => img.src)
      },
      onClose () {
        this.show = false
        this.$emit('close')
      },
      initEvent () {
        const dragDom = this.$el.querySelector('.el-dialog')
        const dialogBodyEl = this.$el.querySelector('.el-dialog__body')
        // const dialogBodyContentEl = this.$el.querySelector('.kye-field-help-body-content')
        // const searchHeight = this.$el.querySelector('.kye-field-help-body-search').offsetHeight
        const headHeight = 40
        const boundaryW = 8 // 边界宽度
        const vm = this

        if (dialogBodyEl) {
          dialogBodyEl[`on${deviceEvent.moveEvent}`] = null

          dialogBodyEl[`on${deviceEvent.moveEvent}`] = function (e) {
            dialogBodyEl[`on${deviceEvent.startEvent}`] = null
            dialogBodyEl.style.cssText += ';cursor:default;'

            let dragPosition = '' // 拖拽方向
            const rect = dragDom.getBoundingClientRect()
            const r = rect.right
            const l = rect.left
            const b = rect.bottom


            if (!dragPosition) {
              // 右边界
              if (e.clientX < r && e.clientX > r - boundaryW) {
                dragPosition = 'r-w'
                dialogBodyEl.style.cssText += ';cursor:ew-resize;'
              }
              // 左边界
              if (e.clientX > l && e.clientX < l + boundaryW) {
                dragPosition = 'l-w'
                dialogBodyEl.style.cssText += ';cursor:ew-resize;'
              }
              // 下边界
              if (e.clientY < b && e.clientY > b - boundaryW) {
                dragPosition = 'b-h'
                dialogBodyEl.style.cssText += ';cursor:ns-resize;'
              }
              // 左下角
              if (e.clientX > l && e.clientX < l + boundaryW && e.clientY < b && e.clientY > b - boundaryW) {
                dragPosition = 'l-wh'
                dialogBodyEl.style.cssText += ';cursor:sw-resize;'
              }
              // 右下角
              if (e.clientY < b && e.clientY > b - boundaryW && e.clientX < r && e.clientX > r - boundaryW) {
                dragPosition = 'r-wh'
                dialogBodyEl.style.cssText += ';cursor:se-resize;'
              }
            }

            // console.log('dragPosition', dragPosition)
            dialogBodyEl[`on${deviceEvent.startEvent}`] = function (e) {
              if (dragPosition) {
                // 拖拽时禁用用户控制文本
                dragDom.style.userSelect = 'none'

                // 鼠标按下，计算当前元素距离可视区的距离
                const dis = getClient(e)
                const disX = dis.x
                const disY = dis.y
                const rect = dialogBodyEl.getBoundingClientRect()
                const rectW = rect.width
                const rectH = rect.height
                let l = parseInt(dragDom.style.left)
                // let maxH = rectH

                const fn = function (e) {
                  // 通过事件委托，计算移动的距离
                  const dis = getClient(e)
                  const left = dis.x - disX
                  const top = dis.y - disY

                  if (dragPosition === 'r-w') {
                    const w = vm.calcWidth(rectW + left)
                    dragDom.style.width = `${w}px`
                    dragDom.style.height = `${rectH + headHeight}px`
                  }
                  if (dragPosition === 'l-w') {
                    const w = vm.calcWidth(rectW - left)
                    dragDom.style.width = `${w}px`
                    dragDom.style.height = `${rectH + headHeight}px`
                  }
                  if (dragPosition === 'b-h') {
                    const h = vm.calcHeight(rectH + top)
                    dragDom.style.height = `${h + headHeight}px`
                    // maxH = h
                  }
                  if (dragPosition === 'l-wh') {
                    const w = vm.calcWidth(rectW - left)
                    const h = vm.calcHeight(rectH + top)
                    dragDom.style.width = `${w}px`
                    dragDom.style.height = `${h + headHeight}px`
                    // maxH = h
                  }
                  if (dragPosition === 'r-wh') {
                    const w = vm.calcWidth(rectW + left)
                    const h = vm.calcHeight(rectH + top)
                    dragDom.style.width = `${w}px`
                    dragDom.style.height = `${h + headHeight}px`
                    // maxH = h
                  }

                  // dialogBodyContentEl.style.height = `${maxH - searchHeight - 12}px`

                  // 宽度到达最大值时，无需左移动
                  if (dragPosition.includes('l')) {
                      let w = parseInt(dragDom.style.width)
                      dragDom.style.left = `${l + (rectW - w)}px`
                  }
                }

                document[`on${deviceEvent.moveEvent}`] = fn

                document[`on${deviceEvent.endEvent}`] = function () {
                  document[`on${deviceEvent.moveEvent}`] = null
                  document[`on${deviceEvent.endEvent}`] = null
                }
              }
            }

            dialogBodyEl[`on${deviceEvent.cancelEvent}`] = function (e) {
              dragDom.style.userSelect = 'auto'
              dragPosition = ''
            }
          }
        }
      },
      /**
       * 获取当前指标说明数据
       */
      async getHelpData () {
        const tip = '<p style="text-align: center;">暂无数据，请您在指标说明模块进行维护！</p>'
        try {
          this.loading = true
          const res = await this.$http('system.indicatorDesc.get', { ...this.form }, { log: false, cancel: true })
          if (res) {
            if (res.indicatorContents && res.indicatorContents.length > 1) {
              this.newContent = res.indicatorContents.map(item => {
                item.originContent = item.indicatorContent
                item.newContent = item.indicatorContent
                item.order = item.order.toString()
                return item
              })
              this.activeName = this.newContent[0].order
            } else {
              this.newContent = (res.indicatorContents && res.indicatorContents[0] && res.indicatorContents[0].indicatorContent) || res.indicatorContent || ''
            }
            this.originContent = cloneDeep(this.newContent)
          } else {
            this.newContent = tip
            this.originContent = ''
          }
          this.loading = false
        } catch (e) {
          this.newContent = tip
          this.originContent = ''
          this.loading = false
        }
      },
      filterChange (val, index = 0, isEndPosition) {
        const originContent = this.multiTab ? this.newContent[index].originContent : this.originContent
        const contentDom = this.multiTab ? this.$el.querySelectorAll('.kye-field-help-body-content')[index] : this.$el.querySelector('.kye-field-help-body-content')
        val = val.trim()
        // 判断是否为特殊字符
        const specialChartsReg = /^[!@#$%^&*()_+\-={};':"\\|,.<>?]+$/

        // 无数据 | 特殊字符不搜索
        if (!originContent || specialChartsReg.test(val)) {
          return
        }

        const keyword = val
        if (!val || !contentDom.textContent.includes(keyword)) {
          if (this.multiTab) {
            contentDom.innerHTML = originContent
          } else {
            this.newContent = originContent
          }
          return
        }
        const highlightTag = `<span class="kye-field-help-body-sign">${keyword}</span>`
        // 替换关键内容，但不替换HTML标签
        const regex = new RegExp(`(${keyword}(?![^<>&]*[>;]))`, 'g')
        const replacedHTML = originContent.replace(regex, highlightTag)

        if (this.multiTab) {
          // 因为el-tab本身的原因，没有实时渲染
          contentDom.innerHTML = replacedHTML
        } else {
          this.newContent = replacedHTML
        }
        this.$nextTick(() => {
          const num = isEndPosition ? Array.from(this.getSignDom(index)).length - 1 : 0
          this.markHighlight(num, index)
        })
      },
      multiPrevClick (tabIndex = 0) {
        const signDom = this.getSignDom(tabIndex)
        const len = Array.from(signDom).length
        const contentDomList = this.$el.querySelectorAll('.kye-field-help-body-content')
        const tabLen = contentDomList.length
        const val = this.searchText
        const hasContent = contentDomList[tabIndex].textContent.includes(val)
        if (len === 0 && hasContent) {
          return
        }
        const goPrevTab = () => {
          let index = tabIndex - 1
          if (index < 0) {
            index = tabLen - 1
          }
          for (let i = index; i >= 0; i--) {
            const contentDom = contentDomList[i]
            if (contentDom.textContent.includes(val)) {
              this.filterTabChange(val, i, true)
              return
            }
          }
          for (let i = tabIndex + 1; i < tabLen; i++) {
            const contentDom = contentDomList[i]
            if (contentDom.textContent.includes(val)) {
              this.filterTabChange(val, i, true)
              return
            }
          }
        }
        const signDomIndex = this.findSignDomIndex(tabIndex)
        if (signDomIndex === 0 || signDomIndex === -1) {
          goPrevTab()
        } else {
          this.markHighlight(signDomIndex - 1, tabIndex)
        }
      },
      multiNextClick (tabIndex = 0) {
        const signDom = this.getSignDom(tabIndex)
        const len = Array.from(signDom).length
        const contentDomList = this.$el.querySelectorAll('.kye-field-help-body-content')
        const tabLen = contentDomList.length
        const val = this.searchText
        const hasContent = contentDomList[tabIndex].textContent.includes(val)
        if (len === 0 && hasContent) {
          this.filterChange(val)
          return
        }
        const goNextTab = () => {
          let index = tabIndex + 1
          if (index === tabLen) {
            index = 0
          }
          for (let i = index; i < tabLen; i++) {
            const contentDom = contentDomList[i]
            if (contentDom.textContent.includes(val)) {
              this.filterTabChange(val, i)
              return
            }
          }
          for (let i = 0; i <= tabIndex; i++) {
            const contentDom = contentDomList[i]
            if (contentDom.textContent.includes(val)) {
              this.filterTabChange(val, i)
              return
            }
          }
        }
        // 当前标记位置
        const signDomIndex = this.findSignDomIndex(tabIndex)
        if (signDomIndex === len - 1 || signDomIndex === -1) {
          goNextTab()
        } else {
          this.markHighlight(signDomIndex + 1, tabIndex)
        }
      },
      // 单页签向下
      singleNextClick (tabIndex = 0) {
        const signDom = this.getSignDom(tabIndex)
        const len = Array.from(signDom).length
        const signDomIndex = this.findSignDomIndex(tabIndex)
        if (len === 0 || signDomIndex < 0) return
        if (signDomIndex === len - 1) {
          this.markHighlight(0, tabIndex)
        } else {
          this.markHighlight(signDomIndex + 1, tabIndex)
        }
      },
      // 单页签向上
      singlePrevClick (tabIndex = 0) {
        const signDom = this.getSignDom(tabIndex)
        const len = Array.from(signDom).length
        const signDomIndex = this.findSignDomIndex(tabIndex)
        if (len === 0 || signDomIndex < 0) return
        if (signDomIndex === 0) {
          this.markHighlight(len - 1, tabIndex)
        } else {
          this.markHighlight(signDomIndex - 1, tabIndex)
        }
      },
      hanldePrevClick () {
        if (this.multiTab) {
          const tabIndex = this.newContent.findIndex(item => item.order === this.activeName)
          this.multiPrevClick(tabIndex)
        } else {
          this.singlePrevClick()
        }
      },
      hanldeNextClick () {
        if (this.multiTab) {
          const tabIndex = this.newContent.findIndex(item => item.order === this.activeName)
          this.multiNextClick(tabIndex)
        } else {
          this.singleNextClick()
        }
      },
      handleTextChange () {
        this.clearSignDom()
        if (this.multiTab) {
          const tabIndex = this.newContent.findIndex(item => item.order === this.activeName)
          this.filterTabChange(this.searchText, tabIndex)
        } else {
          this.filterChange(this.searchText)
        }
      },
      markHighlight (signIndex, tabIndex = 0) {
        const signDom = this.getSignDom(tabIndex)
        const len = Array.from(signDom).length
        for (let i = 0; i < len; i++) {
          const has = signDom[i].classList.contains('highlight')
          if (has) {
            signDom[i].classList.remove('highlight')
          }
        }
        const index = signIndex === len ? 0 : signIndex
        const dom = signDom[index]
        if (dom) {
          dom.classList.add('highlight')
          dom.scrollIntoView({
            behavior: 'smooth'
          })
        }
      },
      hasDom (dom) {
        return dom && Array.from(dom).length > 0
      },
      calcWidth (value) {
        const max = this.getMaxWidth()
        const min = 200
        let w = value > max ? max : value
        w = w < min ? min : w
        return w
      },
      calcHeight (value) {
        const max = this.getMaxHeight()
        const min = 300
        let h = value > max ? max : value
        h = h < min ? min : h
        return h
      },
      getMaxWidth () {
        return document.querySelector('body').clientWidth * 0.5
      },
      getMaxHeight () {
        return document.querySelector('body').clientHeight - 200
      },
      getCurrentContent () {
        if (this.multiTab) {
          const tabIndex = this.newContent.findIndex(item => item.order === this.activeName)
          return this.originContent[tabIndex].indicatorContent
        }
        return this.originContent
      },
      getSignDom (index) {
        const container = this.multiTab ? this.$refs.helpContent[index] : this.$refs.helpContent
        const signDom = container.querySelectorAll('.kye-field-help-body-sign')
        return signDom
      },
      clearSignDom () {
        this.newContent = cloneDeep(this.originContent)
        if (this.multiTab) {
          const contentDomList = this.$el.querySelectorAll('.kye-field-help-body-content')
          contentDomList.forEach((item, index) => {
            item.innerHTML = this.newContent[index].newContent
          })
        }
      },
      // 搜索指定tab的input, val 为搜索文字，index为tab索引，isEndPosition是否从末尾搜索
      filterTabChange (val, index, isEndPosition) {
        this.activeName = this.newContent[index].order
        this.$nextTick(() => {
          this.filterChange(val, index, isEndPosition)
        })
      },
      // 找寻当前高亮索引
      findSignDomIndex (tabIndex) {
        const signDom = this.getSignDom(tabIndex)
        if (!this.hasDom(signDom)) return -1
        const len = Array.from(signDom).length
        for (let i = 0; i < len; i++) {
          const has = signDom[i].classList.contains('highlight')
          if (has) {
            return i
          }
        }
        return -1
      },
      // 点击文本内容-处理文件跳转
      handleContentClick (e) {
        const target = e.target
        if (target.className.includes('ks-quill-upload-file')) {
          const pattern = /url="(.*?)"/ // 截取url内容
          const result = target.outerHTML.match(pattern)
          if (result) {
            const urlContent = result[1]
            window.erpOpen(urlContent)
          }
        } else if (target.tagName === 'IMG') {
          const content = this.getCurrentContent()
          const currentImgSrc = this.getImages(content)
          if (currentImgSrc && currentImgSrc.length > 0 && target.src) {
            const index = currentImgSrc.indexOf(target.src)
            if (index !== -1) {
              openPreview({
                url: currentImgSrc,
                index
              })
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  .kye-field-help {
    .el-tabs__nav-prev {
      bottom:  -8px;
    }
     .el-tabs__nav-next {
      bottom:  -8px;
    }
    .el-dialog {
      display: flex;
      flex-direction: column;
      margin: initial;
      margin-top: 120px!important;
    }
    .el-dialog__header {
      height: 40px;
      padding: 10px 16px;
    }
    .el-dialog__body {
      flex: 1;
      padding: 0!important;
      min-height: 300px;
      // max-height: calc(100vh - 70px);
      max-height: inherit;
      overflow: auto;
      display: flex;
    }
    &-body {
      padding-bottom: 12px;
      overflow: hidden;
      width: 100%;
      &-content {
        user-select: auto;
        padding: 0 16px;
        overflow-y: auto;
        max-height: calc(100vh - 264px);
        box-sizing: border-box;
        font-size: 12px;
        color: #333;
        line-height: 20px;
        img {
          cursor: pointer;
        }
      }
      &-search {
        display:flex;
        padding: 12px 16px;
      }
      &-input {
        .el-input__inner {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right-color: transparent;
          &:hover{
            border-right-color: var(--g-color-primary);
          }
          &:focus{
            border-right-color: var(--g-color-primary);
          }
        }
      }
      &-btn {
        color: #333;
        height: 28px;
        width: 70px;
        align-items: center;
        background-color: #f7f7fd;
        border-radius: 0;
        &:focus {
          background: rgba(139,96,240,0.1);
          border-color: var(--g-color-primary);
          color: var(--g-color-primary);
        }
        &.prev {
          border-right-color: transparent;
          &:focus{
            border-right-color: var(--g-color-primary);
            outline: none;
          }
          &:active{
            border-right-color: var(--g-color-primary);
            outline: none;
          }
          &:hover{
            border-right-color: var(--g-color-primary);
            outline: none;
            &+ .last{
              border-left-color: transparent;
            }
          }
        }
        &.last {
          margin-left: 0!important;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
      &-sign {
        // color: var(--g-color-primary);
        &.highlight {
          color: #FF0000;
          background-color: #FFF8E6;
        }
      }
    }

    .el-tabs {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      height: calc(100% - 55px);
      .el-tabs__content {
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: hidden;
        .el-tab-pane {
          display: flex;
          flex: 1;
          flex-direction: column;
          overflow: hidden;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-field-help/index.vue